import { Accordion, Title } from '@mantine/core';
import { Container, ContentWrapper } from './styles';
import { t } from 'i18next';
import { usePluginSettings } from './use-plugin-settings';
import { StyledScrollArea } from '../template-select/styles';
import { PluginAccordionItem } from '../../molecules/plugin-accordion-item';
import { AllPluginsCheckbox } from '../../molecules/all-plugins-checkbox';

export interface PluginSettingsProps {
  children: (progress: () => void, disabled?: boolean) => JSX.Element;
}

export const PluginSettings = ({ children }: PluginSettingsProps) => {
  const {
    pluginsState,
    togglePlugin,
    setAllPlugins,
    setPluginSetting,
    progressSetup,
  } = usePluginSettings();

  return (
    <>
      <Container>
        <ContentWrapper>
          <Title order={3} fw={500}>
            {t('title.pluginSettings')}
          </Title>
          <AllPluginsCheckbox plugins={pluginsState} onChange={setAllPlugins} />
          <StyledScrollArea h={600} scrollbarSize={4}>
            <Accordion
              multiple
              chevron={null}
              styles={{ content: { padding: 0 } }}
            >
              {pluginsState.map((plugin) => (
                <PluginAccordionItem
                  key={plugin.key}
                  plugin={plugin}
                  checked={plugin.enabled}
                  onToggle={() => togglePlugin(plugin.key)}
                  onSettingChange={setPluginSetting}
                />
              ))}
            </Accordion>
          </StyledScrollArea>
        </ContentWrapper>
      </Container>

      {children(progressSetup, false)}
    </>
  );
};
